module.exports = globalThis.mcData["blocksArray"] ?? globalThis.mcData["blocks"]